import React, { useState } from "react";
import Modal from "react-modal";
import {
  convertStraight,
  convertTo12HourFormat,
  formatDateTime,
} from "../../common-data/Converts";
import { CheckCircleIcon, XCircleIcon } from "../../../images/icons/icons";
import { returnAccurate } from "../../staff-onboarding/detail-modal/GenericFunctions";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";

const RegularizationDetails = ({ rowData }) => {
  const iniModValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  function onCloseModal() {
    setModValues(iniModValues);
  }

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "staff_photo" ? "modal-container-abs" : ""
          }`}
        >
          <ModalHeadAndClose
            title={
              modValues.cardName === "staff_photo"
                ? modValues.rowData?.name
                : modValues.cardName?.replace(/_/g, " ")
            }
            onClose={onCloseModal}
          />

          {modValues.cardName === "staff_photo" ? (
            <div className="discussionModalMessage mt30">
              <img src={modValues.image} alt={modValues.rowData?.name} />
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="user-profile-container staff-onboarding-detail-modal">
        <div className="user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">
                {rowData?.user_account_type?.replace(/_/g, " ")} shift timing
              </p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData.shift_details &&
                Array.isArray(rowData.shift_details) &&
                rowData.shift_details.length > 0
                  ? rowData.shift_details.map((shift, index) => (
                      <p className="info-name" key={index}>
                        {convertTo12HourFormat(shift.start_time)} -{" "}
                        {convertTo12HourFormat(shift.end_time)}
                      </p>
                    ))
                  : "No Shift Found"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">status</p>
            </div>
            <div className="user-details-info">
              <p
                className="info-name info-status"
                style={{
                  background:
                    rowData?.status === "rejected"
                      ? "#cc440a"
                      : rowData?.status === "hr_pending" ||
                        rowData?.status === "manager_pending"
                      ? "#FFEDC0"
                      : "#B4E7B9",
                  color:
                    rowData?.status === "rejected"
                      ? "#fff"
                      : rowData?.status === "hr_pending" ||
                        rowData?.status === "manager_pending"
                      ? "#171717"
                      : "#0A701B",
                }}
              >
                {rowData?.status === "manager_pending"
                  ? "Manager Approval Pending"
                  : rowData?.status === "hr_pending"
                  ? "HR Approval Pending"
                  : rowData?.status === "rejected" && rowData?.hr_id
                  ? "Rejected By HR"
                  : rowData?.status === "rejected" && !rowData?.hr_id
                  ? "Rejected By Manager"
                  : rowData?.status?.replace(/_/g, " ")}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">date</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {convertStraight(rowData?.date) || "-" || "-"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">checkin/checkout time</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.checkin_time || "-"}
                {" - "}
                {rowData?.checkout_time || "-"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">different gym</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.is_different_gym ? (
                  <CheckCircleIcon />
                ) : (
                  <XCircleIcon />
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">reason</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{rowData?.reason || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">checkin proof</p>
            </div>
            <div className="user-details-info">
              {returnAccurate(
                rowData?.checkin_proof,
                rowData?.checkin_proof,
                rowData,
                setModValues
              )}
            </div>
          </div>

          {rowData?.manager_id && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">manager approval date</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {rowData?.manager_approval_date
                    ? formatDateTime(rowData.manager_approval_date)
                    : "-"}
                </p>
              </div>
            </div>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Manager Approval</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.manager_name || "NA"}

                {rowData?.manager_id && (
                  <>
                    <br />
                    <small className="lowercase underline">
                      {rowData?.manager_mobile || ""}
                      <br />
                      {rowData?.manager_email || ""}
                    </small>
                    <br />
                    remarks: {rowData?.manager_remarks || ""}
                  </>
                )}
              </p>
            </div>
          </div>

          {rowData?.hr_id && (
            <div className="user-details">
              <div className="user-details-head">
                <p className="head-name">HR approval date</p>
              </div>
              <div className="user-details-info">
                <p className="info-name">
                  {rowData?.hr_approval_date
                    ? formatDateTime(rowData.hr_approval_date)
                    : "-"}
                </p>
              </div>
            </div>
          )}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">HR Approval</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {rowData?.hr_name || "NA"}

                {rowData?.hr_id && (
                  <>
                    <br />
                    <small className="lowercase underline">
                      {rowData?.hr_mobile || ""}
                      <br />
                      {rowData?.hr_email || ""}
                    </small>
                    <br />
                    remarks: {rowData?.hr_remarks || ""}
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegularizationDetails;
